// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"15918c39","471":"e07f8b64","685":"eefc8fb8","789":"15918c39","878":"30c89833"}[chunkId] + ".chunk.css";
};